import { createContext, useContext, useEffect, useState } from "react";

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rs_lang") || "en");
  useEffect(() => {
    localStorage.setItem("rs_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const L = (en, hi) => (lang === "hi" && hi ? hi : en);
  return <LangCtx.Provider value={{ lang, setLang, L }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
